import { useDispatch, useSelector } from 'react-redux'
import { useEffect } from 'react'
import { actionSetStep } from '@store/reducers/app'
import { ROUTE_UPLOAD } from '@config/constants'
import styles from './StepShowMockup.module.scss'
import BackBtn from '@components/molecules/BackBtn/BackBtn'
import Split from '@components/layouts/Split/Split'
import c from 'classnames'
import { useState } from 'react'
import Text from '@components/atoms/Text/Text'
import Translate from '@components/atoms/Translate/Translate'
import Button from '@components/molecules/Button/Button'
import Toggle from '@components/atoms/Toggle/Toggle'

import { sendEvent } from '@utils/tracking'

const StepShowMockup = () => {
  const dispatch = useDispatch()
  const gtmEvent = {
    name: 'Sujet testen - Step 3, Mockup downloaden',
    category: 'sujet testen',
    action: 'Step 3 - Download Mockup',
  }

  useEffect(() => {
    dispatch(actionSetStep(2))
  }, [])

  const { compositeImages, selectedSujet } = useSelector((state) => state.app)

  const [visibleImg, setVisibleImg] = useState('day')

  const onToggle = () => {
    setVisibleImg((old) => (old === 'day' ? 'night' : 'day'))
  }

  const generateFileName = () =>
    `${selectedSujet.title.toLowerCase().replace(' ', '-')}-${visibleImg}.jpg`

  return (
    <div className={styles.base}>
      <Split hasFullWidth>
        <div className={styles.top}>
          <BackBtn color="white" link={ROUTE_UPLOAD} />

          <div className={styles.toggle} onClick={onToggle}>
            <div className={styles.option}>
              <Toggle isActive={visibleImg === 'day'} />
            </div>
            <Text type="text-s" bold>
              <Translate
                str={
                  visibleImg === 'day'
                    ? 'steps.preview.toggleDay'
                    : 'steps.preview.toggleNight'
                }
              />
            </Text>
          </div>
        </div>
        <div className={styles.main}>
          <a
            href={`data:image/jpg;base64,${compositeImages[visibleImg]}`}
            download={generateFileName()}
          >
            <Button
              bg="white"
              icon="download"
              onClick={() =>
                sendEvent(gtmEvent.name, gtmEvent.category, gtmEvent.action)
              }
            >
              <Translate str="steps.preview.download" />
            </Button>
          </a>
        </div>
        <div className={styles.previews}>
          <img
            className={c({ [styles.visible]: visibleImg === 'day' })}
            src={`data:image/jpg;base64,${compositeImages.day}`}
          />
          <img
            className={c({ [styles.visible]: visibleImg === 'night' })}
            src={`data:image/jpg;base64,${compositeImages.night}`}
          />
        </div>
      </Split>
    </div>
  )
}

export default StepShowMockup
